<template>
  <div>
    <Hero />
    <Questions />
    <Features />
    <SocialProof />
    <Cta />
    <Footer />
  </div>
</template>

<script>
import Hero from "./Hero";
import Questions from "./Questions";
import Features from "./Features";
import SocialProof from "./SocialProof";
import Cta from "./Cta";
import Footer from "./Footer";

export default {
  name: "Main",
  components: {
    Hero,
    Questions,
    Features,
    SocialProof,
    Cta,
    Footer,
  },
};
</script>

<style lang="scss" scoped></style>
